import React, { useCallback, useEffect, useState } from 'react';
import PropTypes from 'prop-types';

import { KEY_MOMENTS_TEAM_LOGO_PLACEHOLDER_SRC } from './keyMomentsTeamLogoPlaceholderSrc';

/**
 * Renders the team crest from the API, falling back to `placeholder-logo-keymoments.svg`
 * when there is no URL or the image errors out.
 */
function KeyMomentsTeamLogoImg({
  teamUrl,
  className,
  alt,
  loading,
}) {
  const initialSrc = teamUrl || KEY_MOMENTS_TEAM_LOGO_PLACEHOLDER_SRC;
  const [src, setSrc] = useState(initialSrc);

  useEffect(() => {
    setSrc(teamUrl || KEY_MOMENTS_TEAM_LOGO_PLACEHOLDER_SRC);
  }, [teamUrl]);

  const handleError = useCallback(() => {
    setSrc(KEY_MOMENTS_TEAM_LOGO_PLACEHOLDER_SRC);
  }, []);

  return (
    <img
      className={className}
      src={src}
      alt={alt}
      loading={loading}
      onError={handleError}
    />
  );
}

KeyMomentsTeamLogoImg.propTypes = {
  teamUrl: PropTypes.string,
  className: PropTypes.string,
  alt: PropTypes.string,
  loading: PropTypes.string,
};

KeyMomentsTeamLogoImg.defaultProps = {
  teamUrl: undefined,
  className: '',
  alt: '',
  loading: 'lazy',
};

export default KeyMomentsTeamLogoImg;
